import { SignInForm } from "../components/SignInForm";

// Landing page for any unsuccessful magic-link click: expired token,
// already-consumed token, missing or malformed token. The Worker's
// /api/auth/callback handler 302s here on any failure path so the user
// gets a clear next step instead of a silent redirect to home.
export function AuthExpiredPage() {
  return (
    <main className="cart-page">
      <div className="wrap" style={{ paddingTop: 60, paddingBottom: 80, maxWidth: 540 }}>
        <h1 className="serif" style={{ fontSize: "clamp(40px, 5vw, 56px)", margin: "0 0 16px", lineHeight: 1.05 }}>
          This link is <span className="it">invalid or expired.</span>
        </h1>
        <p className="serif-it" style={{ color: "var(--ink-soft)", fontSize: 18, margin: "0 0 32px" }}>
          Please enter your email below to request a fresh sign-in link.
        </p>
        <SignInForm />
      </div>
    </main>
  );
}
